import { z } from 'zod'

export const paramsSchema = z.object({
  query: z.string(),
  province: z.string().optional(),
  region: z.string().optional(),
})

export type paramsType = z.infer<typeof paramsSchema>
